// Note utilities for Indian classical music and equal temperament

export const NOTE_NAMES = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B",
];

// Common Bansuri (Indian flute) keys/tonic options
export const TANPURA_KEYS = [
    { label: "C (Safed 1)", note: "C", freq: 261.63 },
    { label: "C# (Kali 1)", note: "C#", freq: 277.18 },
    { label: "D (Safed 2)", note: "D", freq: 293.66 },
    { label: "D# (Kali 2)", note: "D#", freq: 311.13 },
    { label: "E (Safed 3)", note: "E", freq: 329.63 },
    { label: "F (Safed 4)", note: "F", freq: 349.23 },
    { label: "F# (Kali 3)", note: "F#", freq: 369.99 },
    { label: "G (Safed 5)", note: "G", freq: 392.0 },
    { label: "G# (Kali 4)", note: "G#", freq: 415.3 },
    { label: "A (Safed 6)", note: "A", freq: 440.0 },
    { label: "A# (Kali 5)", note: "A#", freq: 466.16 },
    { label: "B (Safed 7)", note: "B", freq: 493.88 },
];

// Convert frequency in Hz to a note name + octave + cents deviation
export function freqToNote(freq) {
    if (!freq || freq <= 0)
        return { note: "—", octave: 0, cents: 0, midi: 0, refFreq: 0 };
    const midi = 69 + 12 * Math.log2(freq / 440);
    const midiRounded = Math.round(midi);
    const cents = Math.round((midi - midiRounded) * 100);
    const octave = Math.floor(midiRounded / 12) - 1;
    const note = NOTE_NAMES[((midiRounded % 12) + 12) % 12];
    const refFreq = 440 * Math.pow(2, (midiRounded - 69) / 12);
    return { note, octave, cents, midi: midiRounded, refFreq };
}
